<template>
<div>
  <div class="row">
    <div class="col-md-8 col-md-offset-2">
      <div
        class="card card-wizard"
        id="wizardCard"
      >
        <form-wizard
          shape="tab"
          @on-complete="wizardComplete"
          @on-validate="handleValidation"
          error-color="#EB5E28"
          color="#66615B"
        >
          <h4 slot="title">{{ title }}</h4>
          <tab-content
            title="Dados Iniciais"
            :before-change="validateInitialDataForm"
            icon="ti-clipboard"
          >
            <initial-data-form ref="initialData"></initial-data-form>
          </tab-content>
          <tab-content
            title="Dados Pessoais"
            :before-change="validatePersonalDataForm"
            icon="ti-settings"
          >
            <personal-data-form ref="personalData"></personal-data-form>
          </tab-content>
          <tab-content
            title="Dados de Endereço"
            :before-change="validatePersonalDataForm"
            icon="ti-map-alt"
          >
            <AddressForm ref="addressData"></AddressForm>
          </tab-content>
          <tab-content
            title="Conclusão"
            icon="ti-check"
          >
            <h5 class="text-center">Cliente cadastrado com sucesso! Escolha uma das opções abaixo.</h5>
            <div class="row">
              <div class="col-md-12 text-center">
                <router-link :to="ticketsRoute">
                  <button
                    :disabled="!enableActionButtons"
                    v-if="$can('customers.tickets')"
                    class="btn btn-lg btn-fill btn-primary"
                  ><i class="fa fa-ticket"></i> Gerar Ticket
                  </button>
                </router-link>
                <router-link :to="lampsRoute">
                  <button
                    :disabled="!enableActionButtons"
                    v-if="$can('customers.lamps')"
                    class="btn btn-lg btn-fill btn-success"
                  ><i class="fa fa-lightbulb-o"></i> Trocar Lâmpadas
                  </button>
                </router-link>
              </div>
            </div>
          </tab-content>
          <button
            slot="prev"
            class="btn btn-default btn-fill btn-wd btn-back"
          >Anterior
          </button>
          <button
            slot="next"
            :disabled="saving"
            class="btn btn-info btn-fill btn-wd btn-next"
          >Próximo
          </button>
          <button
            slot="finish"
            class="btn btn-info btn-fill btn-wd"
          >Finalizar
          </button>
        </form-wizard>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import Couchdb from 'src/services/Couchdb'
import swal from 'sweetalert2'
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import { mapActions, mapGetters } from 'vuex'
import InitialDataForm from './Forms/InitialDataForm.vue'
import PersonalDataForm from './Forms/PersonalDataForm.vue'
import AddressForm from 'src/components/Trg/Customer/AddressForm'

export default {
  components: {
    FormWizard,
    TabContent,
    InitialDataForm,
    PersonalDataForm,
    AddressForm
  },
  data () {
    return {
      customerId: '',
      saving: false,
      model: {},
      docId: '',
      entityName: 'Cliente',
      verfiryingCustomer: false,
      enableActionButtons: false
    }
  },

  computed: {
    ...mapGetters(['user']),
    ...mapGetters('project', {
      config: 'project'
    }),
    ...mapGetters('winners', ['winner']),
    id: function () {
      return this.$route.params.id
    },
    editing: function () {
      return this.id !== undefined
    },
    title: function () {
      return this.editing ? `Editar ${this.entityName}` : `Novo ${this.entityName}`
    },
    lampsRoute: function () {
      if (this.editing) {
        return {
          name: 'customers.lamps',
          params: { id: this.id }
        }
      } else if (this.docId) {
        return {
          name: 'customers.lamps',
          params: { id: this.docId }
        }
      } else {
        return { name: 'customers.index' }
      }
    },
    ticketsRoute: function () {
      if (this.editing) {
        return {
          name: 'customers.tickets',
          params: { id: this.id }
        }
      } else if (this.docId) {
        return { name: 'customers.tickets', params: { id: this.docId } }
      } else {
        return { name: 'customers.index' }
      }
    },

    customer: {
      get: function () {
        return this.$store.state.customers.one
      }
    }
  },

  methods: {
    ...mapActions('project', { fetchProject: 'fetchOne' }),
    ...mapActions('customers', ['fetchOne', 'fetchAll', 'resetOne', 'insert', 'update', 'upsert']),
    ...mapActions('winners', { winnerReset: 'resetOne' }),
    ...mapActions('tickets', { resetTickets: 'resetAll', resetTicket: 'resetOne' }),
    async validateInitialDataForm () {
      const validate = await this.$refs.initialData.validate()
      if (this.editing) {
        return validate
      }
      const result = await this.verifyCustomerExistence()
        .catch(err => console.log(err))
      if (result) {
        this.notifyCustomerExists(result[1])
      } else {
        return validate
      }
    },

    async verifyCustomerExistence () {
      const result = await this.customerDuplicateCheck(
        this.$refs.initialData.model.uc,
        this.$refs.initialData.model.cpf
      )
      return result
    },

    async customerDuplicateCheck (customerUc, customerCpf) {
      this.verfiryingCustomer = true
      const willVerify = this.config.validationCustomer.cpf || this.config.validationCustomer.uc || this.config.validationCustomer.ucOrCpf
      console.log(customerUc, customerCpf)
      return Promise.all([
        Couchdb.connection('default').where('uc', customerUc).limit(1).get(),
        Couchdb.connection('default').where('cpf', customerCpf).limit(1).get()
      ]).then(result => {
        console.log(result)
        if (!willVerify) {
          return false
        }

        if (result[0].length === 0 && result[1].length === 0) {
          return false
        }

        const customer = {
          idUc: false,
          idCpf: false
        }

        if (result[0].length > 0 && result[0][0].uc === customerUc) {
          customer.idUc = result[0][0]._id
        }

        if (result[1].length > 0 && result[1][0].cpf === customerCpf) {
          customer.idCpf = result[1][0]._id
        }

        if (this.validToUcAndCpf(customer)) {
          this.customerId = customer.idUc
          return true
        }

        if (this.validToCpfOrUc(customer)) {
          this.customerId = customer.idUc ? customer.idUc : customer.idCpf
          return true
        }

        if (this.validToUc(customer)) {
          this.customerId = customer.idUc
          return true
        }

        if (this.validToCpf) {
          this.customerId = customer.idCpf
          return true
        }
      }).finally(() => {
        this.verfiryingCustomer = false
      })
    },

    validToUcAndCpf (customer) {
      return this.config.validationCustomer.uc && this.config.validationCustomer.cpf && customer.idUc && customer.idCpf
    },

    validToUc (customer) {
      return this.config.validationCustomer.uc && !this.config.validationCustomer.cpf && customer.idUc
    },

    validToCpf (customer) {
      return !this.config.validationCustomer.uc && this.config.validationCustomer.cpf && customer.idCpf
    },

    validToCpfOrUc (customer) {
      console.log(customer)
      return this.config.validationCustomer.ucOrCpf && (customer.idCpf || customer.idUc)
    },

    notifyCustomerExists (result) {
      swal({
        title: 'Cliente já cadastrado',
        text: 'Deseja editá-lo?',
        type: 'warning',
        showCancelButton: true
      }).then(res => {
        if (res) {
          this.$router.push({
            name: 'customers.edit',
            params: { id: this.customerId }
          })
          this.$router.go(0)
        } else {
          this.$router.push({ name: 'customers.index' })
        }
      }).catch(err => {
        console.log('erro', err)
        this.$router.push({ name: 'customers.index' })
      })
    },

    validatePersonalDataForm () {
      return this.$refs.personalData.validate()
    },

    handleValidation (isValid, tabIndex) {
      if (isValid && tabIndex === 2) {
        this.saving = true
        this.model = {
          ...this.$refs.initialData.model,
          ...this.$refs.personalData.model,
          ...this.$refs.addressData.customer
        }
        let doc = this.id ? Object.assign({}, this.model) : Object.assign({}, this.customer, this.model)
        doc.phones = [
          doc.phone1,
          doc.phone2
        ]
        doc.collection = 'customers'
        doc.userId = !doc.hasOwnProperty('_id') ? this.user._id : doc.userId
        delete doc.tickets
        delete doc.lamps
        this.upsert(doc)
          .then((result) => {
            this.docId = result.id
            this.$notify({
              message: 'Cliente atualizado com sucesso.',
              type: 'success'
            })
            this.enableActionButtons = true
            this.saving = false
          })
          .catch(() => {
            this.saving = false
          })
      }
    },

    wizardComplete () {
      this.$router.push({ name: 'customers.index' })
    },

    resetAll () {
      this.resetTicket()
      this.resetTickets()
      this.resetOne()
      this.winnerReset()
    }
  },

  mounted () {
    this.resetAll()

    if (!this.config._id) {
      this.fetchProject('config')
    }

    if (this.id) {
      this.fetchOne(this.id)
    }

    this.verfiryingCustomer = false
  }
}
</script>
<style>
  .vue-form-wizard .wizard-icon-circle.tab_shape {
    background-color: #9A9A9A !important;
    color: white;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Customers/CustomersForm.vue